<template>
    <div class="WriteoffView">
    </div>
</template>

<script>
  export default {
    name: 'WriteoffView',
    data() {
      return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .WriteoffView {
    }
</style>
